import { render, staticRenderFns } from "./materialCenter.vue?vue&type=template&id=2237d303&"
import script from "./materialCenter.vue?vue&type=script&lang=js&"
export * from "./materialCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports